export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10902.abd5ed37.jpg";